import styles from "./styles.module.scss";
import { ReactComponent as TicketIdIcon } from "icons/ticketIdIcon.svg";
import { ReactComponent as InfoTooltipIcon } from "icons/infoTooltipIcon.svg";
import { ReactComponent as CreatedAtCalenderIcon } from "icons/createdAtCalenderIcon.svg";
import { PrioritySelect } from "pages/support-tickets/components/priority-select";
import { UseLazyApiCallV2 } from "hooks/use-lazy-api-call-v2";
import { Spin, message } from "antd";

export const TicketDetailHeader = ({
  ticketData,
  refetchTicketsData,
  refetchTicketDetail,
}) => {
  const statusOptions = [
    { value: "open", label: "New Tickets", color: "#3B8AFF" },
    { value: "progress", label: "On-Going Tickets", color: "#FAC885" },
    { value: "done", label: "Resolved Tickets", color: "#54C104" },
  ];

  const prioritycolors = {
    lowColor: "#898989",
    mediumColor: "#FF8817",
    highColor: "#D80027",
  };

  const { lowColor, mediumColor, highColor } = prioritycolors;

  const priorityOptions = [
    { value: "low", label: "Low", color: lowColor },
    {
      value: "medium",
      color: mediumColor,
      label: "Medium",
    },
    { value: "high", label: "High", color: highColor },
  ];
  function handleChange(selectedOption, variant) {
    handleUpdateStatusOrPriority({ variant, value: selectedOption.value });
    // open , progress, done
  }
  const STATUS = "status";
  const PRIORITY = "priority";
  const UPDATE_TICKET_STATUS_ENDPOINT = "/update_ticket_status";
  const UPDATE_TICKET_PRIORITY_ENDPOINT = "/update_priority_status";
  const DUMMY_TICKET_ID = "m2c-112-784869";

  const [updateTicketStatus, { isLoading }] = UseLazyApiCallV2({
    url: null,
    method: "POST",
  });

  async function handleUpdateStatusOrPriority({ variant, value }) {
    const endPoint =
      variant === STATUS
        ? UPDATE_TICKET_STATUS_ENDPOINT
        : UPDATE_TICKET_PRIORITY_ENDPOINT;

    try {
      const res = await updateTicketStatus({
        url: endPoint,
        params: {
          ticket_id: ticketData?.ticket_id,
          [variant]: value,
        },
      });
      if (res) {
        const { success, message: apiMessage } = res || {};
        refetchTicketsData();
        refetchTicketDetail();
        return success
          ? message.success(apiMessage)
          : message.error(apiMessage);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }

  function getDefaultSelectedObj({ existingValue, allOptions }) {
    if (!existingValue || !allOptions) return;
    const existingObj = allOptions?.find(
      (item) => item.value === existingValue
    );
    return existingObj;
  }

  const statusExistingOptionObj = getDefaultSelectedObj({
    existingValue: ticketData?.status,
    allOptions: statusOptions,
  });
  const priorityExistingOptionObj = getDefaultSelectedObj({
    existingValue: ticketData?.priority,
    allOptions: priorityOptions,
  });

  function getBGcolor(priority) {
    switch (priority) {
      case "low":
        return lowColor;
      case "medium":
        return mediumColor;
      case "high":
        return highColor;

      default:
        return lowColor;
    }
  }

  return (
    <Spin spinning={isLoading}>
      <div className={styles.headerContainer}>
        <div className={styles.headerLeftSide}>
          <h3>{ticketData?.topic}</h3>
          <div className={styles.ticketId}>
            <TicketIdIcon />
            <span>{ticketData?.ticket_id}</span>
          </div>
          <div
            className={styles.priority}
            style={{ backgroundColor: getBGcolor(ticketData?.priority) }}
          >
            {ticketData?.priority}
          </div>
          <div className={styles.updatedDaysContainer}>
            <InfoTooltipIcon />
            <div className={styles.updatedDays}>
              <p>Updated 4 days ago</p>
              <p>Resolved 4 days ago</p>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            gap: "20px",
            alignSelf: "end",
            marginRight: "10px",
          }}
        >
          <PrioritySelect
            options={statusOptions}
            placeholder="Ticket Status"
            onChange={(e) => handleChange(e, STATUS)}
            variant={"ticket-detail-modal"}
            defaultOption={statusExistingOptionObj}
          />

          <PrioritySelect
            options={priorityOptions}
            placeholder="Select Priority"
            onChange={(e) => handleChange(e, PRIORITY)}
            variant={"ticket-detail-modal"}
            defaultOption={priorityExistingOptionObj}
          />
        </div>
      </div>
      <div className={styles.createdAt}>
        <CreatedAtCalenderIcon />
        <span>Created May 29, 2024 at 1:31 PM</span>
      </div>
    </Spin>
  );
};
